// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3N0FX","content":"LayoutSettings_content__3vfvY"};